import React from 'react';
import { connect } from 'react-redux';
import { userLogout, translate } from 'react-admin';
import LogoutIcon from '../icon/IcnLogout';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import compose from 'recompose/compose';

const MyLogoutButton = ({ translate, userLogout, ...rest }) => (
    <List>
        <ListItem button  onClick={userLogout} {...rest} >
          <LogoutIcon />
          <ListItemText primary={translate("logout.title")} />
        </ListItem>
    </List>
);

const enhance = compose(
    translate,
    connect(undefined, { userLogout })
);

export default enhance(MyLogoutButton);

